import { render, staticRenderFns } from "./NewsLoader.vue?vue&type=template&id=0291e0a4"
import script from "./NewsLoader.vue?vue&type=script&lang=js"
export * from "./NewsLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports